import React, { useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useConfig } from '../../../DataStore/ConfigContext';

const AlertDeleteSignatory = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const {dispatch, deletedSignatory, getSignatories} = useConfig();

    const handleClose = ()=>{
        dispatch({type: 'deletedSignatory', payload: null})
    }

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxConfig.deleteSignatory(deletedSignatory.id);
        setLoading(false);
        if(server_response.status === "OK"){
            getSignatories(true);
            dispatch({type: 'deletedSignatory', payload: null})
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)
        }
        handleClose();
    }

    return (
        <BsModal
            show={deletedSignatory ? true : false}
            onClose={handleClose}
            title="Delete Signatory"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Yes, Delete Signatory
                    </button>
                    </>}
                </>
            }
        >


            <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Are you sure you want to delete this signatory?</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b>{deletedSignatory ? deletedSignatory.last_name + ' ' + deletedSignatory.first_name : ''} will be permanently deleted. This action cannot be undone.
                </p>
           
            </div>
          

        </BsModal>
    );
};

export default AlertDeleteSignatory;
